<template>
  <div>
    <v-dialog scrollable max-width="800px" v-model="model" persistent>
      <material-card
        :title="
          $t('components.new_providers.providers_table.update_billing_info')
        "
        :color="$vuetify.theme.themes.light.secondary"
        icon="folder_shared"
        v-if="item"
      >
        <v-card-text style="margin-top: 20px">
          <v-container fluid>
            <v-form v-model="valid">
              <v-row>
                <div class="col-12 col-xs-12">
                  <no-autocomplete-textfield
                    :label="$t('headers.contacts.email')"
                    v-model="item.Email"
                    :rules="[$rules.required, $rules.email]"
                    class="required"
                  ></no-autocomplete-textfield>
                </div>
                <v-form v-model="validBankAccountForm" ref="bankAccountForm">
                  <v-row>
                    <div class="col-12 col-xs-12">
                      <span>
                        {{
                          $t(
                            "components.claims.provider_dialog.direct_deposit_information"
                          )
                        }}
                      </span>
                    </div>
                    <div class="col-12 col-xs-12 col-sm-6">
                      <no-autocomplete-textfield
                        :label="
                          $t('headers.members_management.Institution Number')
                        "
                        @input="
                          item.InstitutionNumber = $event;
                          tryValidateBankAccount();
                        "
                        :value="item.InstitutionNumber"
                        :rules="[$rules.canadianBankInstitutionNumber]"
                        :class="isBankAccountRequired() ? 'required' : ''"
                      ></no-autocomplete-textfield>
                    </div>
                    <div class="col-12 col-xs-12 col-sm-6">
                      <no-autocomplete-textfield
                        :label="$t('headers.members_management.Account Number')"
                        @input="item.AccountNumber = $event"
                        :value="item.AccountNumber"
                        :rules="[$rules.canadianBankAccountNumber]"
                        :class="isBankAccountRequired() ? 'required' : ''"
                      ></no-autocomplete-textfield>
                    </div>
                    <div class="col-12 col-xs-12 col-sm-6">
                      <no-autocomplete-textfield
                        :label="$t('headers.members_management.Transit Number')"
                        @input="
                          item.TransitNumber = $event;
                          tryValidateBankAccount();
                        "
                        :value="item.TransitNumber"
                        :rules="[$rules.canadianBankTransitNumber]"
                        :class="isBankAccountRequired() ? 'required' : ''"
                      ></no-autocomplete-textfield>
                    </div>
                    <div class="col-12 col-xs-12 col-sm-6">
                      <v-checkbox
                        :label="
                          $t('headers.members_management.Verify Direct Deposit')
                        "
                        v-model="item.VerifyDirectDeposit"
                      ></v-checkbox>
                    </div>
                  </v-row>
                </v-form>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$emit('close')">
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn :disabled="!isValid()" color="primary" @click="save">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="confirmBankAccountDialog"
      persistent
      max-width="500"
    >
      <material-card
        :title="
          $t('components.addmemberwizard.confirm_bank_account_dialog_title')
        "
        :color="$vuetify.theme.themes.light.success"
        icon="done"
      >
        <v-card-actions>
          <v-btn
            color
            text
            @click="confirmBankAccountDialog = false"
            :loading="saving"
          >
            {{ $t("globals.close") }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            @click="
              confirmBankAccountDialog = false;
              bankAccountValid = true;
            "
            :loading="saving"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error" />
  </div>
</template>

<script>
import { translate } from "@/trans";
import { mapGetters, mapActions } from "vuex";
import NoAutocompleteTextfield from "../NoAutocompleteTextfield.vue";
import ErrorHandler from "../ErrorHandler.vue";
export default {
  props: ["model", "billingInfoItem", "providerId", "officeId"],
  components: {
    NoAutocompleteTextfield,
    ErrorHandler,
  },
  data() {
    return {
      item: {},
      confirmBankAccountDialog: false,
      bankAccountValid: true,
      validBankAccountForm: false,
      valid: false,
      error: null,
      saving: false,
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
  },
  watch: {
    billingInfoItem: {
      handler(v) {
        if (v) {
          this.item.AccountNumber = v.AccountNumber;
          this.item.TransitNumber = v.TransitNumber;
          this.item.InstitutionNumber = v.InstitutionNumber;
          this.item.Email = v.Email;
          this.$nextTick(() => {
            if (this.$refs.bankAccountForm) {
              this.$refs.bankAccountForm.validate();
            }
          });
        } else {
          this.item.AccountNumber = null;
          this.item.TransitNumber = null;
          this.item.InstitutionNumber = null;
          this.item.Email = null;
        }
      },
    },
  },
  mounted() {
    if (this.billingInfoItem) {
      this.item.AccountNumber = this.billingInfoItem.AccountNumber;
      this.item.TransitNumber = this.billingInfoItem.TransitNumber;
      this.item.InstitutionNumber = this.billingInfoItem.InstitutionNumber;
      this.item.Email = this.billingInfoItem.Email;
      this.$nextTick(() => {
        if (this.$refs.bankAccountForm) {
          this.$refs.bankAccountForm.validate();
        }
      });
    }
  },
  methods: {
    ...mapActions("plansMembers", ["validateBankAccount"]),
    ...mapActions("claims", ["updateBillingInfo"]),
    isBankAccountRequired() {
      console.log(JSON.stringify(this.item));
      if (
        this.item.AccountNumber !== null &&
        this.item.AccountNumber !== undefined &&
        this.item.AccountNumber !== ""
      ) {
        return true;
      }
      if (
        this.item.TransitNumber !== null &&
        this.item.TransitNumber !== undefined &&
        this.item.TransitNumber !== ""
      ) {
        return true;
      }
      if (
        this.item.InstitutionNumber !== null &&
        this.item.InstitutionNumber !== undefined &&
        this.item.InstitutionNumber !== ""
      ) {
        return true;
      }
      return false;
    },
    isBankAccountValid() {
      if (this.isBankAccountRequired()) {
        return this.validBankAccountForm;
      }
      if (this.$refs.bankAccountForm) {
        this.$refs.bankAccountForm.resetValidation();
      }
      return this.bankAccountValid;
    },
    async tryValidateBankAccount() {
      this.bankAccountValid = true;
      if (
        this.item &&
        this.item.InstitutionNumber &&
        this.item.TransitNumber &&
        this.$rules.canadianBankInstitutionNumber(
          this.item.InstitutionNumber
        ) === true &&
        this.$rules.canadianBankTransitNumber(this.item.TransitNumber) === true
      ) {
        this.saving = true;
        try {
          const valid = (
            await this.validateBankAccount({
              payload: {
                InstitutionNumber: this.item.InstitutionNumber,
                TransitNumber: this.item.TransitNumber,
              },
            })
          ).data;

          if (!valid) {
            this.bankAccountValid = false;
            this.confirmBankAccountDialog = true;
          }
        } catch (error) {
          this.error = error;
        } finally {
          this.saving = false;
        }
      }
    },
    isValid() {
      console.log(
        this.valid,
        this.isBankAccountRequired() && this.isBankAccountValid(),
        !this.isBankAccountRequired()
      );
      if (!this.item) {
        return false;
      }
      return (
        this.valid &&
        ((this.isBankAccountRequired() && this.isBankAccountValid()) ||
          !this.isBankAccountRequired())
      );
    },
    async save() {
      try {
        this.saving = true;
        await this.updateBillingInfo({
          providerId: this.providerId,
          officeId: this.officeId,
          payload: this.item,
        });
        this.$emit("saved", this.item);
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
